// @flow

// import _ from "underscore";

let previousTitle = "";
let previousPath = "";
let gaPageViewLogTimeout;

export default (() => {
    const create = (name, fields) => {
        return {
            event: name,
            ...fields,
        };
    };

    const logPageView = (): any => {
        clearTimeout(gaPageViewLogTimeout);

        gaPageViewLogTimeout = setTimeout(() => {
            // timeout allows for helmet to correctly set any nested meta data

            let stopPolling = false;
            const getPath = (): string => {
                return `${window.location.pathname}${window.location.search}`;
            };

            const isReadyToLog = (): boolean =>
                previousTitle !== document.title && previousPath !== getPath();

            const log = () => {
                previousTitle = document.title;
                previousPath = getPath();
                const pageView = {
                    page_title: document.title,
                    page_location: getPath(),
                };
                // console.log("LOGGING GTM PAGE VIEW", pageView);
                push({
                    event: "pageview",
                    ...pageView,
                });
            };

            const pollForTitleChange = () => {
                if (isReadyToLog()) {
                    log();
                } else if (!stopPolling) {
                    requestAnimationFrame(pollForTitleChange);
                } else {
                    log();
                }
            };

            if (isReadyToLog()) {
                log();
            } else {
                // Start RAFing for the document title chage
                requestAnimationFrame(pollForTitleChange);
                setTimeout(() => {
                    stopPolling = true;
                }, 2000);
            }
        }, 500);
    };

    const push = event => {
        // if (_.has(event, "event")) {
        console.log("LOGGING GTM PUSH", event);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(event);
        // }
    };

    return {
        create,
        push,
        logPageView,
    };
})();
